<template>
  <div>
    <success-fade-alert ref="alert" :msg="alerts.success" />
    <fade-alert-danger ref="danger" :msg="alerts.error" />

    <b-overlay :show="!isInputsEnabled" rounded="lg" opacity="0.6">
      <template #overlay>
        <div class="d-flex align-items-center">
          <!-- <b-spinner class="align-middle"></b-spinner> -->
          <b-spinner></b-spinner>
          <strong>{{ $t("geral.sendingData") }}</strong>
          <!-- <b-spinner small type="grow" variant="secondary"></b-spinner> -->
          <!-- <b-spinner type="grow" variant="dark"></b-spinner> -->
          <!-- <b-spinner small type="grow" variant="secondary"></b-spinner> -->
          <!-- We add an SR only text for screen readers -->
          <!-- <span class="sr-only">Please wait...</span> -->
        </div>
      </template>

      <b-form-textarea
        id="input-description"
        v-model="comment"
        placeholder="Escrever um comentário..."
        :disabled="!isInputsEnabled"
        @click="typingStart"
      />

      <div v-if="isTyping">
        <b-row>
          <b-col>
            <camera-button
              :lang="$i18n.locale"
              :disabled="!isInputsEnabled"
              @update-image-src="fileAdd"
            >
            </camera-button>
          </b-col>
          <b-col class="text-right">
            <span v-if="isCommentLengthValid">{{ commentLength }}/500</span>
            <span v-else class="text-danger"
              >Comentário maior que o permitido. {{ commentLength }}/500</span
            >
          </b-col>
        </b-row>

        <b-row
          class="text-center"
          v-if="attachments != null && attachments.length > 0"
        >
          <b-col md="3" v-for="(attachment, i) in attachments" :key="i">
            <base-attachment-viewer
              class="ml-3 mb-3"
              :attachment="attachment"
              :discard-visible="isInputsEnabled"
              @discard="fileRemove"
            ></base-attachment-viewer>
            <!-- <base-attachment-item
              :attachment="attachment.attachment"
              :discard-visible="isInputsEnabled"
              @discard="fileRemove"
            >
            </base-attachment-item> -->
          </b-col>
        </b-row>

        <div>
          <b-button
            size="sm"
            class="mr-2"
            :disabled="!isInputsEnabled"
            @click="saveComment"
          >
            {{ $t("geral.save") }}
          </b-button>
          <b-button
            size="sm"
            class="mr-2"
            :disabled="!isInputsEnabled"
            @click="typingCancel"
          >
            {{ $t("geral.discard") }}
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
// import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import CameraButton from "@/components_rms/CameraButton.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";

export default {
  components: {
    // "base-attachment-item": BaseAttachmentItem,
    "camera-button": CameraButton,
    FadeAlertDanger,
    SuccessFadeAlert,
    BaseAttachmentViewer,
  },
  props: {
    pendencyId: Number,
  },
  data: function () {
    return {
      alerts: {
        error: "",
        success: "Comentário salvo com sucesso",
      },
      attachments: [],
      comment: "",
      isInputsEnabled: true,
      isTyping: false,
    };
  },
  created: function () {},
  computed: {
    commentLength() {
      if (!this.comment) return 0;
      return this.comment.length;
    },
    isCommentLengthValid() {
      return this.commentLength <= 500;
    },
  },
  methods: {
    fileAdd(newValue) {
      this.attachments.push({ attachment: newValue });
      this.$forceUpdate();
    },
    fileRemove(attachment) {
      for (let i = this.attachments.length - 1; i >= 0; i--) {
        if (this.attachments[i].attachment == attachment) {
          this.attachments.splice(i, 1);
          break;
        }
      }
      this.$forceUpdate();
    },
    saveComment() {
      this.isInputsEnabled = false;

      let pendencyComment = {
        pendencyId: parseInt(this.pendencyId),
        comment: this.comment,
        attachments: [],
      };
      this.attachments.forEach((attach) => {
        let pendencyCommentAttachment = {
          attachment: attach.attachment,
        };
        pendencyComment.attachments.push(pendencyCommentAttachment);
      });

      this.$apiChecklist
        .post("/v1/pendencies/comment/create/", pendencyComment)
        .then((response) => {
          this.$refs.alert.show();
          this.isInputsEnabled = true;
          this.typingCancel();
          this.$emit("after-add");
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            this.alerts.error = `${error.response.status} - ${error.response.statusText}`;
            this.$refs.danger.show();
            this.isInputsEnabled = true;
          } else {
            this.alerts.error = error;
            this.$refs.danger.show();
            this.isInputsEnabled = true;
          }
        });
    },
    typingCancel() {
      this.attachments = [];
      this.comment = "";
      this.isTyping = false;
    },
    typingStart() {
      this.isTyping = true;
    },
  },
};
</script>
